function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8,0 C10.209,0 12,1.791 12,4 C12,6.209 10.209,8 8,8 C5.791,8 4,6.209 4,4 C4,1.791 5.791,0 8,0 Z M16,17.0107 C16,17.3227 15.894,17.6237 15.689,17.8607 C15.059,18.5927 13,19.9997 8,19.9997 C3,19.9997 0.929,18.5827 0.304,17.8527 C0.104,17.6187 0,17.3227 0,17.0147 L0,11.5717 C0,10.1517 1.151,8.9997 2.571,8.9997 L13.429,8.9997 C14.849,8.9997 16,10.1517 16,11.5717 L16,17.0107 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/profile.fb7728e4.svg";
export { SvgComponent as ReactComponent };